var cov_2fyx1fq3gv = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Message/index.ts",
      hash = "4adcfb09f1cf6002eabd0cc6f203dde47987a178",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Message/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 6
        }
      },
      "1": {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "2": {
        start: {
          line: 9,
          column: 38
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "3": {
        start: {
          line: 14,
          column: 13
        },
        end: {
          line: 14,
          column: 55
        }
      },
      "4": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 85
        }
      },
      "5": {
        start: {
          line: 15,
          column: 62
        },
        end: {
          line: 15,
          column: 83
        }
      },
      "6": {
        start: {
          line: 16,
          column: 99
        },
        end: {
          line: 16,
          column: 101
        }
      },
      "7": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "8": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 28,
          column: 6
        }
      },
      "9": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "10": {
        start: {
          line: 41,
          column: 13
        },
        end: {
          line: 41,
          column: 25
        }
      },
      "11": {
        start: {
          line: 43,
          column: 7
        },
        end: {
          line: 45,
          column: 8
        }
      },
      "12": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 18
        }
      },
      "13": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 15
          },
          end: {
            line: 9,
            column: 16
          }
        },
        loc: {
          start: {
            line: 9,
            column: 38
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 38
          },
          end: {
            line: 9,
            column: 39
          }
        },
        loc: {
          start: {
            line: 13,
            column: 5
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 57
          },
          end: {
            line: 15,
            column: 58
          }
        },
        loc: {
          start: {
            line: 15,
            column: 62
          },
          end: {
            line: 15,
            column: 83
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 17,
            column: 52
          },
          end: {
            line: 17,
            column: 53
          }
        },
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 28,
            column: 6
          }
        },
        line: 18
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 40,
            column: 9
          },
          end: {
            line: 40,
            column: 10
          }
        },
        loc: {
          start: {
            line: 40,
            column: 33
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 40
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 43,
            column: 109
          },
          end: {
            line: 43,
            column: 110
          }
        },
        loc: {
          start: {
            line: 43,
            column: 114
          },
          end: {
            line: 45,
            column: 7
          }
        },
        line: 43
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 48,
            column: 14
          },
          end: {
            line: 48,
            column: 15
          }
        },
        loc: {
          start: {
            line: 48,
            column: 43
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 19
          },
          end: {
            line: 16,
            column: 35
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 30
          },
          end: {
            line: 16,
            column: 35
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 44
          },
          end: {
            line: 16,
            column: 58
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 56
          },
          end: {
            line: 16,
            column: 58
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 60
          },
          end: {
            line: 16,
            column: 72
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 66
          },
          end: {
            line: 16,
            column: 72
          }
        }],
        line: 16
      },
      "3": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        }],
        line: 41
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { destroy, getComponent } from './messager';
var defaultOptions = (cov_2fyx1fq3gv.s[0]++, {});
cov_2fyx1fq3gv.s[1]++;

var create = function create(type) {
  cov_2fyx1fq3gv.f[0]++;
  cov_2fyx1fq3gv.s[2]++;
  return function (content, duration, options) {
    cov_2fyx1fq3gv.f[1]++;
    var mo = (cov_2fyx1fq3gv.s[3]++, Object.assign({}, defaultOptions, options));
    cov_2fyx1fq3gv.s[4]++;
    duration = [duration, defaultOptions.duration, 3].find(function (d) {
      cov_2fyx1fq3gv.f[2]++;
      cov_2fyx1fq3gv.s[5]++;
      return typeof d === 'number';
    });

    var _ref = (cov_2fyx1fq3gv.s[6]++, mo),
        onClose = _ref.onClose,
        _ref$position = _ref.position,
        position = _ref$position === void 0 ? (cov_2fyx1fq3gv.b[0][0]++, 'top') : _ref$position,
        title = _ref.title,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? (cov_2fyx1fq3gv.b[1][0]++, '') : _ref$className,
        _ref$top = _ref.top,
        top = _ref$top === void 0 ? (cov_2fyx1fq3gv.b[2][0]++, 'auto') : _ref$top,
        hideClose = _ref.hideClose,
        container = _ref.container;

    cov_2fyx1fq3gv.s[7]++;
    return getComponent({
      position: position,
      container: container
    }).then(function (messager) {
      cov_2fyx1fq3gv.f[3]++;
      cov_2fyx1fq3gv.s[8]++;
      return messager.addMessage({
        content: content,
        duration: duration,
        type: type,
        onClose: onClose,
        title: title,
        className: className,
        top: top,
        position: position,
        hideClose: hideClose
      });
    });
  };
};

export default {
  show: create('default'),
  success: create('success'),
  info: create('info'),
  warn: create('warning'),
  warning: create('warning'),
  danger: create('danger'),
  error: create('danger'),
  close: function close(key) {
    cov_2fyx1fq3gv.f[4]++;
    cov_2fyx1fq3gv.s[9]++;

    if (key) {
      cov_2fyx1fq3gv.b[3][0]++;
      cov_2fyx1fq3gv.s[10]++;
      destroy(key);
    } else {
      cov_2fyx1fq3gv.b[3][1]++;
      ;
      cov_2fyx1fq3gv.s[11]++;
      ['top', 'middle', 'top-left', 'top-right', 'bottom-left', 'bottom-right'].forEach(function (k) {
        cov_2fyx1fq3gv.f[5]++;
        cov_2fyx1fq3gv.s[12]++;
        destroy(k);
      });
    }
  },
  setOptions: function setOptions(options) {
    cov_2fyx1fq3gv.f[6]++;
    cov_2fyx1fq3gv.s[13]++;
    defaultOptions = options;
  }
};